import { Pane, Paragraph, Small } from 'evergreen-ui';
import { Logo } from '.';

const EmptyIcon = () => <Pane height="20px" width="20px" />;

const Header = ({
  padding,
  logoSize,
  extendedLogo,
  subTitle,
  LeftIcon,
  onLeftIconClick,
  RightIcon,
  onRightIconClick,
}) => {
  return (
    <Pane display="flex" flexDirection="column" alignItems="center" padding={padding}>
      <Pane
        display="flex"
        position="relative"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        width="100%"
      >
        <Pane
          display="flex"
          position="absolute"
          left={0}
          justifyContent="center"
          alignItems="center"
          padding="16px"
          onClick={onLeftIconClick}
        >
          {LeftIcon || <EmptyIcon />}
        </Pane>
        <Pane display="flex" flexDirection="column" alignItems="center">
          <Logo size={logoSize} extended={extendedLogo} />
        </Pane>
        <Pane
          display="flex"
          justifyContent="center"
          alignItems="center"
          paddingX="16px"
          paddingY="0px"
          position="absolute"
          right={0}
          onClick={onRightIconClick}
        >
          {RightIcon || <EmptyIcon />}
        </Pane>
      </Pane>
      <Paragraph>
        <Small color="#F0F0F2" opacity="0.7">
          {subTitle}
        </Small>
      </Paragraph>
    </Pane>
  );
};

export default Header;
